import { createAction } from 'redux-act';

export const displayAlert = createAction<{
  type: 'success' | 'info' | 'error';
  message: string;
}>('alert/ALERT_DISPLAY');

export const cleanupAlert = createAction('alert/ALERT_CLEANUP');

export const showAlert = createAction('alert/ALERT_SHOW');

export const hideAlert = createAction('alert/ALERT_HIDE');
